import { ServerEventsClient } from '@servicestack/client';
import { ToastUtil } from 'bz-core-controls/controls/utils/toast';
import AuthStore from 'bz-stores/lib/auth-store';
import useUnmountEffect from 'bz-utilities/hooks/unmount-effect';
import { useState } from 'react';
import type { ServerError, ServerNotification, ServerSuccess } from './models';

interface IProps {}

const ApiNotifications: React.FC<IProps> = () => {
  const [serverEventsClient] = useState(() => {
    if (!AuthStore.user.clientId) return;
    const channels = [`${AuthStore.user.clientId}/channels/notifications`];

    const client = new ServerEventsClient('/api/', channels, {
      handlers: {
        ServerNotification: (res: ServerNotification) => {
          if (res.userId && AuthStore.user.id !== res.userId.toString()) return;

          if (res.requireDismiss)
            ToastUtil.setMessage('information', res.title, res.message, [], null, {
              duration: Infinity
            });
          else ToastUtil.information(res.title, res.message);
        },
        ServerError: (res: ServerError) => {
          if (res.userId && AuthStore.user.id !== res.userId.toString()) return;
          ToastUtil.error(res.message, { duration: Infinity });
        },
        ServerSuccess: (res: ServerSuccess) => {
          if (res.userId && AuthStore.user.id !== res.userId.toString()) return;
          ToastUtil.success(res.message);
        }
      }
    });
    client.start();
    return client;
  });

  useUnmountEffect(() => {
    serverEventsClient?.stop();
  });

  return null;
};

export default ApiNotifications;
